// extracted by mini-css-extract-plugin
export default {"dialog":"style--dialog--4cbb4e"};